import React, { useState } from 'react'
import { Button, Col, Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Label } from 'reactstrap'

import ReactDatetime from "react-datetime";
import { apiFichajesService } from 'services/apiFichajesService';
import { showAppAlert } from "components/common/AppAlerts";
import { useAuth } from 'context/AuthProvider';

const FichajeManual = (props) => {
    const { empresa } = useAuth();
    const [fecha, setFecha] = useState();
    const [hora, setHora] = useState();
    const [tipo, setTipo] = useState('entrada');
    const [motivoAjuste, setMotivoAjuste] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        const json = {
            empleadoId: Number(props.empleadoId),
            empresaId: empresa.id,
            horaFichaje: fecha.format("YYYY-MM-DD") + "T" + hora.format("HH:mm:SS") + ".000000",
            tipo: tipo,
            origen: "manual",
            motivoAjuste: motivoAjuste
        }

        await apiFichajesService.ficharManual(json)
        showAppAlert("Cargado correctamenteo", "success")

        setMotivoAjuste("");
        props.handleUpdate();
    }

    return (
        <Form onSubmit={handleSubmit}>
            <FormGroup row>
                <Col lg={6} sm={12} className="mb-1">
                    <Label>Dia:</Label>
                    <InputGroup className="input-group-alternative" >
                        <InputGroupAddon addonType="prepend" >
                            <InputGroupText>
                                <i className="ni ni-calendar-grid-58" />
                            </InputGroupText>
                        </InputGroupAddon>
                        <ReactDatetime
                            inputProps={{
                                placeholder: "Seleccione el dia del fichaje",
                                required: true
                            }}
                            timeFormat={false}
                            dateFormat={"DD-MM-YYYY"}
                            closeOnSelect
                            value={fecha}
                            onChange={(e) => setFecha(e)}
                            required
                        />
                    </InputGroup>
                </Col>

                <Col lg={6} sm={12} className="mb-1">
                    <Label>Hora:</Label>
                    <InputGroup className="input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                                <i className="ni ni-calendar-grid-58" />
                            </InputGroupText>
                        </InputGroupAddon>
                        <ReactDatetime
                            inputProps={{
                                placeholder: "Seleccione la hora del fichaje",
                                required: true
                            }}
                            timeFormat={true}
                            dateFormat={false}
                            value={hora}
                            onChange={(e) => setHora(e)}
                        />
                    </InputGroup>
                </Col>
                <Col lg={12} sm={12} className="mb-1">
                    <Label>Motivo del ajuste:</Label>
                    <Input
                        type="text"
                        placeholder="Indique el motivo del fichaje manual"
                        value={motivoAjuste}
                        onChange={(e) => setMotivoAjuste(e.target.value)}
                        required
                    />
                </Col>
            </FormGroup>
            <Col lg={12} className="text-right p-0">
                <Button type='submit' value={"entrada"} color='success' onClick={(e) => setTipo(e.target.value)}>
                    Entrada
                </Button>
                <Button type='submit' value={"salida"} color='danger' onClick={(e) => setTipo(e.target.value)}>
                    Salida
                </Button>
            </Col>
        </Form>
    )
}

export default FichajeManual
